export default __webpack_public_path__ + "static/media/icon_social-pinterest.8220843a.svg";